import axios from 'axios'
const server_url = 'https://ec2-18-220-238-160.us-east-2.compute.amazonaws.com:5000/'

export const getSeniorsShiftsByWardId = ward => {
    console.log(ward.ward_id)
    return axios
    .post(server_url + 'shifts_seniors/get_by_ward_id', {ward_id: ward.ward_id})
    .then(res => {
        console.log(res);
        return res.data;
    }).catch(err => {
        console.log(err.response)
    })
}

export const updatePriority = priority => {
    return axios
    .post(server_url + 'priorities/update', {
        id: 1,
        emergency: priority.emergency,
        waiting_period: priority.waiting_period,
        number_of_cancellation: priority.number_of_cancellation,
        complexity: priority.complexity,
        age: priority.age,
        operation_time: priority.operation_time,
        elective_priority: priority.elective_priority
    })
    .then(res => {
        return res;
    })
    .catch(err => {
        console.log('Error: ' + err)
    })
}


export const getOrthopedicWardStaff = orthopedic_ward_id => {
    console.log(orthopedic_ward_id);
    return axios
    .post(server_url + 'surgeonseniors/byWardIdFullInfo', {
        ward_id: orthopedic_ward_id
    }).then(res => {
        console.log(res);
        return res.data;
    }).catch(err => {
        console.log(err.response)
    })
}


export const getSurgeries = () => {
    return axios
    .get(server_url + 'surgeries', {
    })
    .then(res => {
        return res
    })
    .catch(err => {
        console.log(err.response)
    })
}

export const addSurgerySurgical = new_surgery => {
    console.log(new_surgery)
    return axios
    .post(server_url + 'surgery_requests/add_surgery_request', {
        request_id: new_surgery.request_id,
        patient_id: new_surgery.patient_id,
        surgery_type_fk: new_surgery.surgery_type_fk,
        urgency: new_surgery.urgency,
        complexity: new_surgery.complexity,
        duration: new_surgery.duration === '' ? '-1' : new_surgery.duration,
        status: new_surgery.status,
        cancellations: new_surgery.cancellations === '' ? '-1' : new_surgery.cancellations,
        entrance_date: new_surgery.entrance_date,
        specific_senior: new_surgery.specific_senior ? new_surgery.specific_senior : null,
        pre_op_date: new_surgery.pre_op_date ? new_surgery.pre_op_date : null,
        scheduling_from: new_surgery.scheduling_from ? new_surgery.scheduling_from : null,
        scheduling_deadline: new_surgery.scheduling_deadline ? new_surgery.scheduling_deadline : null,
        description: new_surgery.description,
    })
    .then(res => {
        return res;
    })
    .catch(err => {
        return err.response;
    })
}

export const addPatient = new_patient => {
    console.log(new_patient)
    return axios
    .post(server_url + 'patients/add_patient', {
        patient_id: new_patient.patient_id,
        first_name: new_patient.first_name,
        last_name: new_patient.last_name,
        gender: new_patient.gender,
        address: new_patient.address,
        phone_number: new_patient.phone_number,
        date_of_birth: new_patient.date_of_birth,
        email: new_patient.email
    })
    .then(res => {
        return res;
    })
    .catch(err => {
        return err.response;
    })
}

export const addPreOPReq = new_req => {
    return axios
    .post(server_url + 'ptswaiting/add', {
        patient_id: new_req.patient_id,
        surgeryT_id: new_req.surgeryT_id,
        urgency: new_req.urgency,
        request_date: new_req.request_date,
        notes: new_req.notes,
        
    })
    .then(res => {
        return res;
    })
    .catch(err => {
        console.log('Error: ' + err.response)
    })
}

export const activateNoaSchedulingAlgorithm = new_req => {
    return axios
    .get(server_url + 'surgeries_surgical/activate_noa_scheduling_algorithm', {
    })
    .then(res => {
        return res;
    })
    .catch(err => {
        console.log('Error: ' + err.response)
    })
}

export const activateYairSchedulingAlgorithm = new_req => {
    return axios
    .get(server_url + 'surgeries_orthopedic/activate_yair_scheduling_algorithm', {
    })
    .then(res => {
        return res;
    })
    .catch(err => {
        console.log('Error: ' + err.response)
    })
}

export const getSurgeriesRequests = body => {
    console.log(body.ward_id);
    return axios
    .post(server_url + 'surgery_requests/get_all_by_ward_id', {
        ward_id: body.ward_id
    })
    .then(res => {
        return res;
    })
    .catch(err => {
        console.log('Error: ' + err.response)
    })
}

export const getRoomsAllocations = body => {
    console.log(body.ward_id);
    return axios
    .post(server_url + 'rooms_allocations/get_by_ward_id', {
        ward_id: body.ward_id
    })
    .then(res => {
        return res;
    })
    .catch(err => {
        console.log('Error: ' + err.response)
    })
}